//
//
//
//
//
//
//
//
//

import {
  mapGetters,
  mapMutations,
} from 'vuex'
import eventBus from './eventBus.js'

export default {
  name: 'CJumpPage',

  components: {},

  props: {
    dom: { type: String },

    beforeClick: { type: Function },

    level: {
      type: [
        String,
        Number,
      ],
      default: 1,
    },

    cacheComponent: {
      type: [
        Object,
        String,
      ],
    },

    component: {
      type: [
        Object,
        String,
      ],
      default: () => {

      },
    },
  },

  data () {
    return {
      currentCacheUid: '',
      currAliveComponent: [],
    }
  },

  computed: {
    ...mapGetters('cache', [
      'scrollTop',
      'aliveComponents',
    ]),
    currScrollTop () {
      return this.scrollTop
    },
  },

  watch: {
    '$route' (to, from) {
      if (this.dom && from.name === 'TOtherPage') {
        this.SET_ALIVE_SCROLL_TOP_BY_DOM({
          dom: this.dom,
          scrollTop: this.currScrollTop,
        })
      }

      if (to.name !== 'TOtherPage' && from.name !== 'TOtherPage') {
        this.SET_ALIVE_COMPONENTS([])
      }
    },
  },

  async mounted () {
    // eventBus.$on('input', (value) => {
    //   this.$emit('input', value)
    // })

    // eventBus.$on('on-change-options', (options) => {
    //   this.options = options
    // })
    eventBus.$on(`return-cache-page${this._uid}`, ({ cacheUid }) => {
      this.currentCacheUid = cacheUid

      this.$emit('return-cache-page')

      // console.log(this.currScrollTop, '234324234')
      //
      // this.$emit('return-cache-page', ...args)
      // this.SET_ALIVE_SCROLL_TOP_BY_DOM('.base-info-write', this.currScrollTop)

      // this.SET_ALIVE_COMPONENTS([])
    })

    // eventBus.$on('on-change-options', (options) => {
    //   this.options = options
    // })
  },

  methods: {
    ...mapMutations('cache', [
      'SET_ALIVE_COMPONENTS',
      'SET_ALIVE_SCROLL_TOP_BY_DOM',
      'SET_ALIVE_COMPONENTS_DATA',
    ]),
    click () {
      this.handlerClick()
    },

    async handlerClick () {
      let flag = true

      if (this.beforeClick) {
        flag = await this.beforeClick()

        if (!flag) {
          return
        }
      }

      await this.goOtherPage()
    },

    async goOtherPage () {
      this.SET_ALIVE_SCROLL_TOP_BY_DOM({ dom: this.dom })
      this.currAliveComponent = this.aliveComponents

      if (this.cacheComponent) {
        this.currAliveComponent = this.currAliveComponent.concat([this.cacheComponent])
      } else {
        this.currAliveComponent = this.currAliveComponent.concat([this.$route.name])
      }

      this.SET_ALIVE_COMPONENTS([...this.currAliveComponent])

      const params = {
        level: this.level,
        ...this.$attrs,
        ...this.$props,
        listeners: this.$listeners,
        cacheUid: this._uid,
        cSelectGoRouter: true,
      }

      this.SET_ALIVE_COMPONENTS_DATA({
        key: `t-other-page-${this.level}`,
        data: params,
      })

      await this.$nextTick()
      this.$router.push({
        name: 'TOtherPage',
        params,
      })
    },
  },
}
